// extracted by mini-css-extract-plugin
export default {"logo_box":"Footer_logo_box__07ybM","sns_box":"Footer_sns_box__JSFpR"};